import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.49 17.5996L13.6 24.7696C12.9 25.1896 12 24.6896 12 23.8696V15.8696C12 12.3796 15.77 10.1996 18.8 11.9396L23.39 14.5796L25.48 15.7796C26.17 16.1896 26.18 17.1896 25.49 17.5996Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0888 23.4567L22.0388 25.7967L17.9988 28.1267C16.5488 28.9567 14.9088 28.7867 13.7188 27.9467C13.1388 27.5467 13.2088 26.6567 13.8188 26.2967L26.5288 18.6767C27.1288 18.3167 27.9188 18.6567 28.0288 19.3467C28.2788 20.8967 27.6388 22.5667 26.0888 23.4567Z",
			fill: "white"
		})
	]
});
export default SvgPlay;
